class FFAboutStats extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.ff-about-stats__item'));
    if (!this.items.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const item = entry.target;
          if (item.dataset.animated === 'true') return;
          item.dataset.animated = 'true';
          item.classList.add('is-visible');
          this.animateItem(item);
        });
      },
      { threshold: 0.35 }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  animateItem(item) {
    const numberEl = item.querySelector('.ff-about-stats__number');
    const valueEl = item.querySelector('.ff-about-stats__number-value');
    if (!numberEl || !valueEl) return;

    const raw = numberEl.dataset.count || '0';
    const rangeMatch = raw.match(/^(\d+)\s*[-–]\s*(\d+)$/);

    if (rangeMatch) {
      this.animateRange(valueEl, parseInt(rangeMatch[1], 10), parseInt(rangeMatch[2], 10));
      return;
    }

    const target = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(target)) {
      valueEl.textContent = raw;
      return;
    }

    this.animateNumber(valueEl, target, raw.includes(',') || target >= 1000);
  }

  animateNumber(el, target, useComma) {
    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(target * eased);
      el.textContent = useComma ? current.toLocaleString('en-AU') : String(current);
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  animateRange(el, start, end) {
    const duration = 1400;
    const t0 = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(start + (end - start) * eased);
      el.textContent = String(current);
      if (progress < 1) requestAnimationFrame(tick);
      else el.textContent = `${start}-${end}`;
    };

    requestAnimationFrame(tick);
  }
}

customElements.define('ff-about-stats', FFAboutStats);
